<div class="pb-20">
  <div class="header-style">
    <div></div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)"></mat-paginator>
      <mat-icon data-testid="add_departments_button" (click)="addDepartment()" class="cursor add-icon" svgIcon="add" aria-hidden="false"></mat-icon>
      
      @if (departmentsList.length > 0) {
        <mat-menu #exportMenu="matMenu">
          <button mat-menu-item i18n="@@exportCSV" (click)="exportDepartments(1)">Export as CSV</button>
          <button mat-menu-item i18n="@@exportPDF" (click)="exportDepartments(2)">Export as PDF</button>
          <button mat-menu-item i18n="@@exportExcel" (click)="exportDepartments(3)">Export as Excel</button>
        </mat-menu>
        <mat-icon svgIcon="export" class="cursor export-icon" i18n-aria-label="@@exportIcon" aria-label="Export" [matMenuTriggerFor]="exportMenu"></mat-icon>
      }
      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input i18n-placeholder="@@searchPlaceholder" data-testid="departments_search_input" matInput formControlName="search" id="search" placeholder="Search" name="search"/>
            <mat-icon data-testid="departments_clear_button" class="cursor" i18n-aria-label="@@clearSearchIcon" aria-label="Clear search" matSuffix (click)="clearSearch()">clear</mat-icon>
          </mat-form-field>
        }
      </form>
      <mat-icon data-testid="departments_search_button" (click)="handleSearchClick()" class="cursor" svgIcon="search" i18n-aria-label="@@searchIcon" aria-label="Search" aria-hidden="false"></mat-icon>
    </div>
  </div>
  @for (item of departmentsList; track item; let itemIndex = $index) {
    <mat-card data-testid="edit_departments_button" (click)="editDepartment(item.id, item.name)" class="cursor simple-card ">
      <mat-card-content class="flex-grow d-flex justify-content-between w-100">
        <div class="mat-subtitle-1" matTooltip ellipsisTooltip>{{item.name}}</div>
        <mat-icon data-testid="delete_departments_button" (click)="deleteDepartment(item.id)" color="warn" class="cursor" i18n-aria-label="@@deleteDepartmentIcon" aria-label="Delete Department" aria-hidden="false">delete_outline</mat-icon>
      </mat-card-content>
    </mat-card>
  }
  @if (departmentsList.length === 0) {
    <img class="empty-view-img" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" i18n-alt="@@emptyDepartmentsImageAlt" alt="No departments available">
  }
</div>
